import n from "clsx";
import t from "react";
import { s as l } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function p({
  size: e = "small",
  accessibilityTitle: r = "glyph star solid",
  className: s,
  "data-testid": a,
  fill: o,
  stroke: i
}) {
  const m = () => n(s, l["ride-glyph"], {
    [l[`size-${e}`]]: e
  });
  return /* @__PURE__ */ t.createElement("div", { className: m(), "data-testid": a }, /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: o || "#03050F",
      stroke: i || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    r && /* @__PURE__ */ t.createElement("title", null, r),
    /* @__PURE__ */ t.createElement("path", { d: "M17.2401 4.3599L20.2301 10.4099C20.4001 10.7599 20.7401 10.9999 21.1201 11.0599L27.8101 12.0299C28.9501 12.1899 29.4001 13.5899 28.5801 14.3899L23.7401 19.0999C23.4601 19.3699 23.3301 19.7599 23.4001 20.1499L24.5401 26.7899C24.7301 27.9199 23.5501 28.7899 22.5301 28.2499L16.5501 25.1099C16.2101 24.9299 15.8001 24.9299 15.4501 25.1099L9.47012 28.2499C8.45012 28.7799 7.27013 27.9199 7.46013 26.7899L8.60013 20.1399C8.67013 19.7599 8.54012 19.3599 8.26012 19.0899L3.42012 14.3899C2.60012 13.5899 3.05013 12.1899 4.19013 12.0299L10.8801 11.0599C11.2601 10.9999 11.6001 10.7599 11.7701 10.4099L14.7601 4.3599C15.2701 3.3299 16.7401 3.3299 17.2501 4.3599H17.2401Z" })
  ));
}
export {
  p as RideGlStarSolid
};
